import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import { Dayjs } from 'dayjs';
import { DateFormat } from 'constants/DateFormat';
import { DayChangeContainer, MonthChangeButton, MonthDisplayContainer } from './styles';

const DayChangeComponent = (props: {
  day: Dayjs;
  onChangeDay: (day: Dayjs, direction: number) => void;
}): JSX.Element => {
  const { day, onChangeDay } = props;
  return (
    <DayChangeContainer>
      <MonthChangeButton>
        <KeyboardArrowLeft onClick={() => onChangeDay(day, -1)} />
      </MonthChangeButton>
      <MonthDisplayContainer>
        {day.format(DateFormat.DAY_FULL)} {day.format(DateFormat.DAY_NUMBER)} {day.format(DateFormat.MONTH_FULL)}
      </MonthDisplayContainer>
      <MonthChangeButton>
        <KeyboardArrowRight onClick={() => onChangeDay(day, 1)} />
      </MonthChangeButton>
    </DayChangeContainer>
  );
};

export default DayChangeComponent;
